import React, { useState } from "react";
import {
    Avatar,
    Box,
    Button,
    Paper,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const SignUp = () => {
    /* ---------------- state ---------------- */
    const [form, setForm] = useState({
        userName: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [message, setMessage] = useState("");

    /* -------------- nav + media ------------ */
    const navigate = useNavigate();
    const theme = useTheme();
    const downSm = useMediaQuery(theme.breakpoints.down("sm")); // <600 px

    /* -------------- handlers --------------- */
    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const callBackend = () => {
        axios
            .post("https://music-endpoint.onrender.com/auth/signup", form)
            .then(({ data }) => {
                setMessage(data.message);
                if (data.message === "Registered successfully") {
                    setTimeout(() => navigate("/auth"), 2000);
                }
            })
            .catch((err) =>
                setMessage(err.response?.data?.message || "Signup failed.")
            );
    };

    /* -------------- render ----------------- */
    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: { xs: "100%", sm: 420, md: 400 },
                    p: { xs: 3, sm: 4 },
                    display: "flex",
                    flexDirection: "column",
                    gap: 2.5,
                    alignItems: "center",
                    borderRadius: { xs: 0, md: 4 }, // rounded only on laptop+
                }}>

                <Avatar sx={{ bgcolor: "black", width: 56, height: 56 }}>
                    <AccountCircleOutlinedIcon fontSize="large" />
                </Avatar>

                <Typography variant={downSm ? "h5" : "h4"}>Sign up</Typography>

                <TextField
                    label="Username"
                    name="userName"
                    value={form.userName}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="Password"
                    name="password"
                    type="password"
                    value={form.password}
                    onChange={handleChange}
                    fullWidth
                />
                <TextField
                    label="Confirm password"
                    name="confirmPassword"
                    type="password"
                    value={form.confirmPassword}
                    onChange={handleChange}
                    fullWidth
                />

                <Button variant="contained" fullWidth onClick={callBackend}>
                    Sign up
                </Button>

                <Typography variant="body2" color="green">
                    {message}
                </Typography>

                <Typography variant="body2">
                    Already have an account? <Link to="/auth">Login</Link>
                </Typography>
            </Paper>
        </Box>
    );
};

export default SignUp;
